import { reducer as toastrReducer } from 'react-redux-toastr'

export default toastrReducer
